import PropTypes from "prop-types";
import { extendedColors, abbreviateNumber } from "../ReportsHelper";
import NoData from "../NoData";
import ReportChart from "./ReportChart";
import { VictoryPie, VictoryLegend } from "victory";
import { ReportChartConsts } from "../ReportTooltips";

export default function WpByLobChart({ data }) {
    const labelColor = document.documentElement.getAttribute('data-gdstheme') === 'dark' ? "#ffffff" : "#000000";

    let noData = !data || data.length === 0 || data.every(d => d.WrittenPremium === 0);
    if (!noData) {
        data = data.filter(d => d.WrittenPremium > 0)
    }

    data = data.filter(d => d.LineOfBusiness !== "Total")

    return (
        <ReportChart {...ReportChartConsts('wpByLob')}>
            {noData ? <NoData /> : <>
                <VictoryLegend
                    orientation="horizontal"
                    gutter={20}
                    height={20}
                    data={data.map((d, index) => ({
                        name: d.LineOfBusiness,
                        symbol: { fill: extendedColors[index] },
                    }))}
                    style={{
                        labels: { fill: labelColor },
                    }}
                />
                <VictoryPie
                    data={data.map(d => ({ x: d.LineOfBusiness, y: d.WrittenPremium }))}
                    colorScale={extendedColors}
                    labels={({ datum }) => abbreviateNumber(datum.y)}
                    style={{
                        labels: { fill: labelColor },
                    }}
                    padding={70}
                    labelIndicator
                />
            </>}
        </ReportChart>
    )
}

WpByLobChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            LineOfBusiness: PropTypes.string,
            WrittenPremium: PropTypes.number,
        })
    ),
};